import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type LocationState = {
  returnTo?: string;
};

const OpenSourceOverlay: React.FC = () => {
  const location = useLocation<LocationState>();

  if (location.pathname === '/open-source') {
    return null;
  }

  const returnTo = `${location.pathname}${location.search}${location.hash}`;

  return (
    <div
      style={{
        position: 'fixed',
        left: 10,
        bottom: 6,
        zIndex: 2147483647,
        pointerEvents: 'none',
      }}
    >
      <Link
        to={{
          pathname: '/open-source',
          state: { returnTo },
        }}
        style={{
          color: 'rgba(180, 180, 180, 0.9)',
          fontSize: 11,
          lineHeight: '14px',
          textDecoration: 'none',
          pointerEvents: 'auto',
        }}
      >
        Compliance
      </Link>
    </div>
  );
};

export default OpenSourceOverlay;
